import {
	AdjustEventName,
	EventIdentifier,
	type EventParams,
	FeatureTeamEvent,
	TrackingEventType,
	useAnalytics
} from '@capsicum/common';
import { WebViewEvents } from '@capsicum/socios-core';
import { useUserIdsAtom } from '@capsicum/socios-gateway/data-access';
import { useCallback } from 'react';

export const useSendAnalyticsEventFromGateway = () => {
	const { userId } = useUserIdsAtom();
	const analytics = useAnalytics();

	const sendPFFTAnalyticsEvent = useCallback(
		(
			eventText: EventIdentifier | string,
			parameters?: EventParams,
			eventType?: EventIdentifier,
			postMessage?: AdjustEventName | false | WebViewEvents
		): void => {
			if (postMessage) {
				switch (postMessage) {
					case WebViewEvents.ADJUST_EVENT:
						window.ReactNativeWebView?.postMessage(
							JSON.stringify({
								eventName: WebViewEvents.ADJUST_EVENT,
								purchase_amount: parameters?.fiat_amount,
								user_id: userId
							})
						);
						break;
					case AdjustEventName.TOPUP_COMPLETED:
						window.ReactNativeWebView?.postMessage(
							JSON.stringify({
								currency_id: parameters?.currency,
								currency_rate: parameters?.currency_rate,
								eventName: postMessage,
								purchase_amount: parameters?.fiat_amount,
								user_id: userId
							})
						);
						break;
					case WebViewEvents.TOP_UP_EVENT:
						window.ReactNativeWebView?.postMessage(
							JSON.stringify({
								eventName: WebViewEvents.TOP_UP_EVENT,
								eventType: eventType || EventIdentifier.ButtonClicked,
								feature_team: FeatureTeamEvent.PFFT,
								text: eventText,
								user_id: userId,
								...parameters
							})
						);
						break;
					default:
						analytics.sendEvent(TrackingEventType.track, eventType || EventIdentifier.ButtonClicked, {
							feature_team: FeatureTeamEvent.PFFT,
							text: eventText,
							user_id: userId,
							...parameters
						});
						break;
				}
			}
		},
		[userId, analytics]
	);

	return { sendPFFTAnalyticsEvent };
};
